<template>
    <div class="screen">
        <h1>Ops...</h1>
        <p>Estamos realizando algumas sincronizações e este processo pode demorar um pouco, volte em 10 minutos...</p>
        <img src="../assets/img/offline.svg">
    </div>
</template>

<script>

  export default {
    name: 'Disponibility'

  }

</script>

<style scoped>
    .screen {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.9);
        padding: 40px;
        z-index: 99999999999;
    }

    .screen > h1 {
        font-size: 30px;
        font-weight: 900;
        color: #222;
        margin-bottom: 10px;
        text-align: center;
    }

    .screen > p {
        font-size: 15px;
        font-weight: 300;
        color: #555;
        margin-bottom: 60px;
        text-align: center;
    }

    .screen > img {
        width: 300px;
        object-fit: contain;
    }
</style>
